/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "//assets.alicdn.com/g/global-footer/0.0.1/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(6);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(3);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/@alife/mscc-porter/index.js
var mscc_porter = __webpack_require__(1);
var mscc_porter_default = /*#__PURE__*/__webpack_require__.n(mscc_porter);

// EXTERNAL MODULE: ./node_modules/@alife/mscc-cookie/index.js
var mscc_cookie = __webpack_require__(0);
var mscc_cookie_default = /*#__PURE__*/__webpack_require__.n(mscc_cookie);

// CONCATENATED MODULE: ./src/common/utils.js
function insertStyle(type, config) {
  var styles = commonCss(config);
  styles += type === 'pc' ? pcCss() : wrapCss();

  if (document.all) {
    window.style = styles;
    document.createStyleSheet("javascript:style");
  } else {
    var style = document.createElement('style');
    style.type = 'text/css';
    style.innerHTML = styles;
    document.getElementsByTagName('HEAD').item(0).appendChild(style);
  }
}
function insertDocument(dom, id) {
  var tag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'div';
  if (!dom) return 'document不能为空';
  if (!id) return 'className不能为空';
  var wrap = document.createElement(tag);
  wrap.id = id;
  wrap.className = id;
  wrap.innerHTML = dom;
  document.body.appendChild(wrap, document.body);
}
function jsonp(url, name, cb) {
  window[name] = cb;
  url = "".concat(url, "&callback=").concat(name);
  var script = document.createElement('script');
  script.setAttribute('src', url);
  document.getElementsByTagName('head')[0].appendChild(script);
}
var deviceType = window.navigator.userAgent.toLowerCase().match(/(ipod|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) !== null ? 'wap' : 'pc';
;
var formatDate = function formatDate(fmt) {
  var o = {
    "M+": this.getMonth() + 1,
    //月份
    "d+": this.getDate(),
    //日
    "h+": this.getHours(),
    //小时
    "m+": this.getMinutes(),
    //分
    "s+": this.getSeconds(),
    //秒
    "q+": Math.floor((this.getMonth() + 3) / 3),
    //季度
    "S": this.getMilliseconds() //毫秒

  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));

  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
  }

  return fmt + '-';
};
var parseStr = function parseStr(str) {
  var result = {
    status: false,
    data: {},
    msg: ''
  };

  if (str) {
    try {
      result.data = JSON.parse(str);
      result.status = true;
    } catch (err) {
      result.msg = err;
    }
  }

  return result;
};
var isCsFormPage = function isCsFormPage() {
  var url = window.location;
  var isFrom = urlParse();

  if (url.pathname === "/messages/send.html" && !isFrom.view) {
    return true;
  }

  return false;
};
var isCsSuccessPage = function isCsSuccessPage() {
  var url = window.location;
  var isFrom = urlParse();

  if (url.pathname === "/messages/send.html" && isFrom.view) {
    return true;
  }

  return false;
};
var isContainerPathname = function isContainerPathname(pathnames) {
  if (!pathnames.length) return false;
  var url = window.location;
  return pathnames.indexOf(url.pathname) >= 0;
};
var urlParse = function urlParse(url) {
  var param = new Object();
  var item = new Array();

  if (location.search == "") {
    return param;
  }

  ;
  var query = location.search.substring(1);
  var list = query.split('&');

  for (var i = 0; i < list.length; i++) {
    item = list[i].split('=');

    if (typeof param[item[0]] == "undefined") {
      param[item[0]] = '';
    }

    param[item[0]] = item[1];
  }

  ;
  return param;
};
var isInApp = function isInApp() {
  return /WindVane/i.test(window.navigator.userAgent);
};
var isAndroid = function () {
  return /Android/i.test(window.navigator.userAgent);
}();
function generateUUID() {
  var d = new Date().getTime();
  var uuid = 'Dxxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
  return "7".concat(uuid.replace(/-/g, ''), "UG");
}
;
// CONCATENATED MODULE: ./src/common/localStorage.js
function isSupportStorage() {
  if (window.localStorage) {
    window.localStorage.setItem('test_localstorage', 123);

    if (window.localStorage.getItem('test_localstorage') == 123) {
      window.localStorage.removeItem('test_localstorage');
      return true;
    }

    return false;
  }

  return false;
}
function getStorage(key) {
  if (!isSupportStorage()) return '';
  return window.localStorage.getItem(key);
}
function setStorage(key, value) {
  if (!isSupportStorage()) return '';
  return window.localStorage.setItem(key, value);
}
function removeStorage(key) {
  if (!isSupportStorage()) return '';
  return window.localStorage.removeItem(key);
}
// CONCATENATED MODULE: ./src/listen-download-app/pageSchema.js
/* harmony default export */ var pageSchema = ({
  home: {
    ios: 'iPhoneHome',
    andriod: 'sc-home'
  },
  detail: {
    ios: 'detail?id=',
    andriod: 'detail?id='
  },
  ma: {
    ios: 'myAlibaba',
    andriod: 'sc-home?frag=MA'
  },
  list: {
    ios: 'list',
    andriod: 'list'
  },
  chat: {
    ios: 'atmTalking',
    andriod: 'atmTalking'
  },
  messageList: {
    ios: 'messageMain',
    andriod: 'sc-home?frag=Messenger'
  }
});
// CONCATENATED MODULE: ./src/listen-download-app/index.js




var cna = mscc_cookie_default.a.getCna();
var pageid = window.dmtrack_pageid;
var language = mscc_cookie_default.a.getLanguage();
var isNewUser = mscc_cookie_default.a.getIsNewUser();
var aliBeaconId = mscc_cookie_default.a.core.get('aliBeaconId');
var username = /^x_lid=([^&]+)/.test(mscc_cookie_default.a.core.get('xman_us_t')) ? RegExp.$1 : '';

function listenDownloadApp() {
  var bodyDom = document.body;
  bodyDom.addEventListener('click', function (e) {
    var count = 0; // 防止形成死循环

    var currentDom = e.target;

    while (currentDom !== bodyDom && count < 50) {
      count++;

      if (currentDom.className.indexOf('new-download-app') < 0) {
        currentDom = currentDom.parentNode;
        continue;
      }

      currentDom.dataset && handlerDownloadApp(currentDom.dataset);
      break;
    }
  });
}

function handlerDownloadApp(_ref) {
  var ck = _ref.ck,
      _ref$page = _ref.page,
      page = _ref$page === void 0 ? 'home' : _ref$page,
      _ref$cancel = _ref.cancel,
      cancel = _ref$cancel === void 0 ? false : _ref$cancel,
      _ref$linkParams = _ref.linkParams,
      linkParams = _ref$linkParams === void 0 ? '' : _ref$linkParams,
      _ref$schemaParams = _ref.schemaParams,
      schemaParams = _ref$schemaParams === void 0 ? '' : _ref$schemaParams;
  aplusDot(ck, cancel ? 'cancel' : 'download');
  if (cancel) return;

  var _pageSchema = handlerPageSchema(page);

  var schemaLink = "enalibaba://".concat(_pageSchema);

  if (schemaParams) {
    schemaLink = "enalibaba://".concat(_pageSchema).concat(_pageSchema.indexOf('?') < 0 ? '?' : '').concat(schemaParams);
  }

  var wakeLink = "".concat(schemaLink).concat(schemaLink.indexOf('?') < 0 ? '?' : '').concat(/\?$/.test(schemaLink) ? '' : '&', "cross=msiteJs&ck=").concat(ck, "&cna=").concat(cna, "&pageid=").concat(pageid);
  var dynamicLink = "https://app.alibaba.com/dynamiclink?schema=".concat(encodeURIComponent(schemaLink), "&bts=new&ck=").concat(ck).concat(linkParams && "&".concat(linkParams), "&cna=").concat(cna, "&pageid=").concat(pageid, "&language=").concat(language, "&isNewUser=").concat(isNewUser, "&username=").concat(username, "&aliBeaconId=").concat(aliBeaconId);

  var _uuid = generateUUID();

  if (isAndroid) {
    // 尝试直接唤醒APP
    window.location.href = wakeLink;
    setTimeout(function () {
      // 打点
      mscc_porter_default.a.get("".concat(dynamicLink, "&click_id=").concat(_uuid)); // 跳转到应用市场

      window.location.href = "market://details?id=com.alibaba.intl.android.apps.poseidon&referrer=click_id%3D".concat(_uuid);
    }, 100);
  } else {
    window.location.href = "".concat(dynamicLink, "&click_id=").concat(_uuid);
  }
}

function handlerPageSchema(page) {
  var mobileType = isAndroid ? 'andriod' : 'ios';
  var commonSchema = pageSchema[page] ? pageSchema[page][mobileType] : pageSchema['home'][mobileType]; // 差异化处理

  var pathname = window.location.pathname;

  if (page === 'detail') {
    var matchResult = pathname.match(/\/product\/(\d+)\//) || pathname.match(/\/p-detail\/.+-(\d+)/);
    commonSchema += matchResult[1] + '&';
  }

  return commonSchema;
}

function aplusDot(ck, action) {
  if (!window.goldlog) {
    throwLog('goldlog不存在。无法发送打点');
  }

  window.goldlog && window.goldlog.record('/sc.mobile.download-app', 'CLK', "ck=".concat(ck, "&action=").concat(action, "&spm=").concat(goldlog.spm_ab.length ? goldlog.spm_ab.join('.') : '', "&pageid=").concat(window.dmtrack_pageid), 'GET');
}

function throwLog(msg) {
  if (!msg) return;
  console.log("\u5168\u5C40\u5F15\u6D41JS\uFF1A".concat(msg));
}

/* harmony default export */ var listen_download_app = (listenDownloadApp);
// EXTERNAL MODULE: ./src/modules/download-app/smart/index.scss
var smart = __webpack_require__(7);
var smart_default = /*#__PURE__*/__webpack_require__.n(smart);

// CONCATENATED MODULE: ./src/modules/download-app/smart/index.js



var downloadAppHtml = function downloadAppHtml(config) {
  return "\n  <div class=\"download-app-content clearfix\">\n    <img class=\"app-logo\" src=\"".concat(config.imageUrl, "\" />\n    <p>").concat(config.titleContent, "</p>\n  </div>\n  <div class=\"download-app-actions\">\n    <span id=\"smart-cancel\" class=\"new-download-app app-not-now\" data-ck=\"wap_smartbanner\" data-cancel=\"true\">").concat(config.notNowButton, "</span>\n    <span id=\"smart-download\" class=\"new-download-app app-download\" data-ck=\"wap_smartbanner\" data-page=\"home\" data-link-params=\"bucketName=").concat(config.bucketName, "\">").concat(config.viewInAppButton, "</span>\n  </div>\n");
};

function DownloadApp(config) {
  var _this = this;

  var defautlConfig = {
    bucketName: '',
    id: 'smart-download-app-wrap',
    notNowButton: 'NOT NOW',
    viewInAppButton: 'Download app',
    titleContent: 'Download now to find exclusive discounts on the app.',
    imageUrl: 'https://gw.alicdn.com/tfs/TB1u2YsHa6qK1RjSZFmXXX0PFXa-100-100.gif'
  };
  this.showState = false;
  this.config = Object.assign(defautlConfig, config);

  this.init = function () {
    // 如果页面中已经存在，则直接显示即可
    if (document.getElementById('smart-download')) {
      _this.show(true);

      return;
    } // 实例化dom结构


    var DomFragment = downloadAppHtml(_this.config);
    insertDocument(DomFragment, _this.config.id); // 监听关闭事件

    document.getElementById('smart-cancel').addEventListener('click', function (e) {
      _this.hide();
    });
  };

  this.hide = function () {
    var ele = document.getElementById(_this.config.id);
    if (!_this.showState || !ele) return;
    _this.showState = false;
    document.getElementById(_this.config.id).className = "".concat(_this.config.id, " close"); // 300ms后自动清空dom

    setTimeout(function () {
      ele.parentNode.removeChild(ele);
    }, 300);
  };

  this.show = function (noLog) {
    var ele = document.getElementById(_this.config.id);
    if (_this.showState || !ele) return;
    _this.showState = true;
    document.getElementById(_this.config.id).className = "".concat(_this.config.id, " show");
    noLog && _this.dot();
  }; // 后面增加曝光功能后，会全部下掉


  this.dot = function () {
    // status 0曝光 1取消 2下载
    if (!_this.config.bucketName) return;
    window.goldlog && window.goldlog.record('/sc.mobile.download-app', 'CLK', "action=expose&ck=wap_smartbanner&bucketName=".concat(_this.config.bucketName, "&pageid=").concat(window.dmtrack_pageid), 'GET');
  }; // 初始化的时候自动调用init


  this.init();
} // 初始化


/* harmony default export */ var download_app_smart = (DownloadApp);
// EXTERNAL MODULE: ./src/modules/download-app/force/index.scss
var force = __webpack_require__(8);
var force_default = /*#__PURE__*/__webpack_require__.n(force);

// CONCATENATED MODULE: ./src/modules/download-app/force/controller.js


var controller_pathname = location.pathname;
var urlParams = urlParse(window.location.href);
var htmlName = document.querySelector('html').getAttribute('name');
/**
 * 1、针对页面做判断是否需要展示
 * 2、疲劳度控制
 */
// 控制是否显示强制引流

/**
 * 
 * 1、先生成对应页面的config 包含页面ck等信息和是否显示
 * 2、判断当前是否是seo、引流等条件，限制展示
 * 3、根据疲劳度，控制是否需要再次展示
 * 
 * 返回config
 */

function init(defaultConfig) {
  // 生成对应页面的config
  var config = generatePageConfig(defaultConfig); // console.log(config.needShow);

  if (config.needShow) {
    // 判断当前是否需要限制展示
    config.needShow = judgeIsNeedShow();
  }

  ;
  return config;
} // 生成对应页面的config


function generatePageConfig(_config) {
  var matchResult = '';

  if (window.__appName === 'wap2') {
    if (window.__pageUrl === '/home') {
      _config.page = 'home';
      _config.needShow = true;
    } else if (window.__pageUrl === '/detail') {
      _config.page = 'detail';
      _config.needShow = true;
    } else if (window.__pageUrl === '/search') {
      _config.page = 'list';
      _config.needShow = true;
      _config.pageSchema = "keyword=".concat(urlParams.SearchText);
    }
  }

  if (window.__pageUrl === '/searchweb/buy/productSearchResultAsyn.vhtml') {
    // 商品搜索列表
    if (htmlName === 'wapseo:list-keyword') {
      var keyword = ''; // https://m.alibaba.com/trade/search?SearchText=mp3

      if (controller_pathname === '/trade/search') {
        _config.page = 'list';
        keyword = urlParams.SearchText; // https://m.alibaba.com/products/mp3/2.html
      } else if (matchResult = controller_pathname.match(/\/products\/([\s\S]+?)(?:\/\d+)?\.html/)) {
        keyword = matchResult[1];
      }

      _config.page = 'list';
      _config.needShow = true;
      _config.pageSchema = "keyword=".concat(keyword); // 类目搜索
    } else if (htmlName === 'wapseo:list-category') {
      // https://m.alibaba.com/Adapters_pid100009649
      if (matchResult = controller_pathname.match(/\/(.+)_pid(.+)/)) {
        _config.page = 'list';
        _config.needShow = true;
        _config.pageSchema = "categoryId=".concat(matchResult[2], "&categoryName=").concat(matchResult[1]); // https://m.alibaba.com/catalogs/--100009649/2
      } else if (matchResult = controller_pathname.match(/\/catalogs\/-*(\d+)/)) {
        _config.page = 'list';
        _config.needShow = true;
        _config.pageSchema = "categoryId=".concat(matchResult[1]);
      } // SEO列表

    } else if (htmlName === 'wapseo:seo-list-showroom') {
      // https://m.alibaba.com/showroom/grease/--1001/2.html
      if (matchResult = controller_pathname.match(/\/showroom\/(.+)\/-+(\d+)/)) {
        _config.page = 'list';
        _config.needShow = true;
        _config.pageSchema = "cateName=".concat(matchResult[1], "&cateId=").concat(matchResult[2]); // https://m.alibaba.com/showroom/mp3.html
      } else if (matchResult = controller_pathname.match(/\/showroom\/(.+)\.html/)) {
        _config.page = 'list';
        _config.needShow = true;
        _config.pageSchema = "keyword=".concat(matchResult[1]);
      }
    } // 多语言搜索列表

  } else if (window.__pageUrl === '/multilanguage/mlProductListAsyn.vhtml') {
    if (htmlName.indexOf('ml-list-') > -1) {
      // https://m.thai.alibaba.com/products/MP3/2.html
      if (matchResult = controller_pathname.match(/\/products\/([\s\S]+?)(?:\/\d+)?\.html/)) {
        _config.page = 'list';
        _config.needShow = true;
        _config.pageSchema = "keyword=".concat(matchResult[1]); // https://m.thai.alibaba.com/Auction_pid2802   
      } else if (matchResult = controller_pathname.match(/\/(.+)_pid(.+)/)) {
        _config.page = 'list';
        _config.needShow = true;
        _config.pageSchema = "categoryId=".concat(matchResult[2], "&categoryName=").concat(matchResult[1]);
      }
    } else if (htmlName.indexOf('ml-product-list-') > -1) {
      // https://m.thai.alibaba.com/Popular/CN_MP3-Trade.html
      if (matchResult = controller_pathname.match(/Popular\/(?:\w+)_(.+)-Trade(?:\/\d+)?\.html/)) {
        _config.page = 'list';
        _config.needShow = true;
        _config.pageSchema = "keyword=".concat(matchResult[1]);
      }
    } // 产品detail

  } else if (window.__pageUrl == '/detail/introductionDetail.vhtml' || window.__pageUrl == '/multilanguage/mlProductDetail.vhtml') {
    _config.page = 'detail';
    _config.needShow = true;
  } // 当为付费引流的承接页时，当前会话不显示强制浮层  只在承接页不显示，detail还是显示， bug营销


  if (urlParams.src === 'cpm_fb') {
    // sessionStorage.notShowForceDialog = true
    _config.needShow = false;
  }

  return _config;
} // 控制是否需要展示


function judgeIsNeedShow() {
  var pageNeedShow = true; // SEO渠道不弹框

  if (window.isSEOChannel === 'true' || htmlName === 'wapseo:seo-list-showroom') {
    pageNeedShow = false;
  }

  ; // 处理当前会话不展示的逻辑

  if (sessionStorage.notShowForceDialog) {
    pageNeedShow = false;
  } // 如果需要展示，则判断是否满足疲劳度需求
  // console.log(pageNeedShow)


  if (pageNeedShow) {
    pageNeedShow = judgeFatigueShow();
  }

  return pageNeedShow;
} // 控制疲劳度


function judgeFatigueShow() {
  // 如果不支持localstorage则 不显示强制引流
  if (!isSupportStorage()) return false;
  var lastTime = getStorage('openAppTime');
  var nowTime = Date.now(); // 控制疲劳度

  var gap = handlerBeatenGap(); // console.log(lastTime, (nowTime - lastTime), gap)

  if (!lastTime || lastTime && nowTime - lastTime > gap) {
    setStorage('openAppTime', nowTime);
    return true;
  }

  return false;
} // 控制疲劳度时间


function handlerBeatenGap() {
  var gap = 24 * 60 * 60 * 1000; // 只有当为首页的时候才为7天的疲劳度，其他的都是1天

  if (window.__appName === 'wap2' && window.__pageUrl === '/home') {
    gap = gap * 7;
  }

  return gap;
}

/* harmony default export */ var controller = (init);
// CONCATENATED MODULE: ./src/modules/download-app/force/index.js




var force_downloadAppHtml = function downloadAppHtml(config) {
  return "\n  <div id=\"force-download-app\" class=\"force-download-app\">\n    <div class=\"dialog-mask\"></div>\n    <div class=\"dialog-container\">\n      <div class=\"dialog-title\" role=\"title-text\">".concat(config.titleContent, "</div>\n      <div class=\"dialog-buttons\">\n        <div id=\"force-download\" data-ck=\"").concat(config.ck, "\" data-page=\"").concat(config.page, "\" data-schema-params=\"").concat(config.pageSchema, "\" class=\"new-download-app download-button\">").concat(config.viewInAppButton, "</div>\n        <div id=\"force-cancel\" data-ck=\"").concat(config.ck, "\" data-cancel=\"true\" class=\"new-download-app cancel-button\">").concat(config.cancelButton, "</div>\n      </div>\n    </div>\n  </div>\n");
};

function force_DownloadApp() {
  var _this = this;

  if (!window.__downloadApp) return;
  var i18n = window.__downloadApp.force.i18n;
  this.defauleConfig = {
    id: 'force-download-app-wrap',
    ck: 'wap_force_dialog',
    page: 'home',
    pageSchema: '',
    needShow: false,
    cancelButton: i18n.cancel || 'Cancel',
    viewInAppButton: i18n.open || 'Open',
    titleContent: i18n.title || 'Continue in Alibaba.com App'
  };
  this.config = {};
  this.showState = false;

  this.init = function () {
    // 根据页面传递配置，显示不同的数据
    _this.config = controller(_this.defauleConfig); // 如果页面中已经存在，则不再继续渲染

    if (document.getElementById(_this.config.id)) return; // 实例化dom结构

    var DomFragment = force_downloadAppHtml(_this.config);
    insertDocument(DomFragment, _this.config.id); // console.log(this.config.needShow)
    // 判断是否需要显示引流框

    if (_this.config.needShow) {
      _this.show();
    } // 监听关闭事件


    document.getElementById('force-cancel').addEventListener('click', function (e) {
      _this.hide();
    });
  };

  this.hide = function () {
    var ele = document.getElementById(_this.config.id);
    if (!_this.showState || !ele) return;
    _this.showState = false;
    document.getElementById(_this.config.id).className = "".concat(_this.config.id, " close"); // 300ms后自动清空dom

    setTimeout(function () {
      ele.parentNode.removeChild(ele);
    }, 300);
  };

  this.show = function () {
    var ele = document.getElementById(_this.config.id);
    if (_this.showState || !ele) return;
    _this.showState = true;
    document.getElementById(_this.config.id).className = "".concat(_this.config.id, " show");

    _this.dot();
  };

  this.handlerPageConfig = function () {}; // 后面增加曝光功能后，会全部下掉


  this.dot = function () {
    // 为了兼容现有的全站统一的引流打点规范，先暂时做的hack
    window.addEventListener('load', function () {
      window.goldlog && window.goldlog.record('/sc.mobile.download-app', 'CLK', "action=expose&ck=wap_force_dialog&pageid=".concat(window.dmtrack_pageid, "&spm=").concat(goldlog.spm_ab.length ? goldlog.spm_ab.join('.') : ''), 'GET');
    });
  }; // 初始化的时候自动调用init


  this.init();
} // 初始化


/* harmony default export */ var download_app_force = (force_DownloadApp);
// CONCATENATED MODULE: ./src/index.js






 // import Questionnaire from './modules/questionnaire';
// 只有不在APP的情况下才执行逻辑

if (!isInApp()) src_init();

function src_init() {
  // 监听所有引流点击
  listen_download_app(); // 显示智能引流，后端不愿意控制，就只能显示在前端了

  ~function handlerSmartDA() {
    var isMsite = /^m.*alibaba.com$/.test(window.location.host);
    var notShowPathnames = ['/login.html', '/register.htm', '/atmHistory', '/atmChatRoom'];

    if (isMsite && !isCsFormPage() && !isContainerPathname(notShowPathnames)) {
      showSmartDA();
    }

    function showSmartDA() {
      // 声明常量
      var APPNAME = 'wap2';
      var APPID = 'icbu_wap2';
      var APPKEY = 'zmgzskyts9twmwzymd5jzsiho72lviws';
      var apushClient = null; //预发
      // Apush2.serverDomain = 'hz-apush-fb.aliexpress.com';
      //线上

      Apush2.serverDomain = 'hzapush.aliexpress.com';
      Apush2.port = 80; // 和Apush建立链接
      // 临时hack 当为询盘表单页面时，不弹出引流框

      if (!apushClient) {
        var TokenUrl = "/openservice/apushAuthorizeTokenService?appKey=".concat(APPKEY, "&appName=").concat(APPNAME, "&cna=").concat(mscc_cookie_default.a.getCna());
        var terminalId = null; //不填则系统生成一个随机字符窜作为terminalId

        var terminalType = null; //不填则系统默认为pc

        apushClient = Apush2.createClient(APPID, TokenUrl, msgCallback, terminalId, terminalType, connectCallback);
      } // 成功建立链接


      function connectCallback(msg) {
        // 和后端建立连接，发送当前refer和cna等信息
        var sendRerferUrl = "/openservice/drainageTimeViewService?appKey=".concat(APPKEY, "&appName=").concat(APPNAME, "&pageReferer=").concat(window.document.referrer);
        mscc_porter_default.a.get(sendRerferUrl);
      } // 处理收到的消息


      function msgCallback(msg) {
        var result = parseStr(msg.arg) || {}; // 如果服务器端要求关闭链接，则关闭

        if (result.data.needCloseConnection) {
          closeClient();
        } // 业务逻辑处理


        if (msg.msgType === "timeDrainageMsg") {
          if (!result.status) return; // 因为每次的弹框都不一样，所以需要初始化弹框

          var smartDA = new download_app_smart(result.data);
          smartDA.show();
        }
      } //断开连接并销毁client


      function closeClient() {
        if (apushClient != null) {
          apushClient.close();
          apushClient = null;
        }
      }
    }
  }(); // 显示强制引流

  ~function handlerForceDA() {
    new download_app_force();
  }(); // 显示问卷，临时把控制权写在前端，后期会对接到后端
  // ~ function handlerQuestionnaire() {
  //   const { pathname } = window.location;
  //   // 首页问卷
  //   if (pathname === '/') {
  //     showQuestionnaire('homepage', 'hasQuestionnaireShowIndex');
  //   }
  //   // detail页问卷 因为和新手引导冲突，所以暂时下掉
  //   // if (/^\/product\//.test(pathname)) {
  //   //   showQuestionnaire('detail', 'hasQuestionnaireShowDetail');
  //   // }
  //   // Message问卷
  //   if (/^\/atmHistory/.test(pathname)) {
  //     showQuestionnaire('message', 'hasQuestionnaireShowMessage');
  //   }
  //   // 询盘成功页问卷 
  //   if (isCsSuccessPage()) {
  //     showQuestionnaire('cs-success', 'hasQuestionnaireShowCsSuccess');
  //   } 
  //   // 订单失败页问卷
  //   if (pathname === '/order/start_error.html') {
  //     showQuestionnaire('order-fail', 'hasQuestionnaireShowDetailOrderFail');
  //   }
  //   function showQuestionnaire (page, localStorage) {
  //     if (getStorage(localStorage)) return;
  //     setStorage(localStorage, true);
  //     // 显示问卷
  //     window.__questionnaire({
  //       source: page
  //     });
  //   }
  // }()
}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
};

var _fetchJsonp = __webpack_require__(4);

var _fetchJsonp2 = _interopRequireDefault(_fetchJsonp);

var _araleEvents = __webpack_require__(5);

var _araleEvents2 = _interopRequireDefault(_araleEvents);

var _msccCookie = __webpack_require__(0);

var _msccCookie2 = _interopRequireDefault(_msccCookie);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof2(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof2(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * Created by 易晓峰(林异)<yxf@106063@alibaba-inc.com> on 16/5/12.
 * 统一对异步数据进行处理
 */
// Ocean 接口变更，配合 native 做修改，当检测到页面 UA 包含 HavanaSession 时，在请求头增加参数


var isHavanaSession = navigator && navigator.userAgent && navigator.userAgent.indexOf('HavanaSession') > -1;

var addHavanaSession = function addHavanaSession(url, options) {
  url = url || '';

  if (isHavanaSession && /^(https?:\/\/)(gateway\.alibaba\.com|gw\.api\.alibaba\.com)/.test(url)) {
    if (options && options.headers instanceof Headers) {
      options.headers.append('havanaSession', 'true');
    } else {
      options = Object.assign({}, options);
      options.headers = Object.assign({}, options.headers, {
        'havanaSession': 'true'
      });
    }
  }

  return options;
}; //错误类


var PorterError = function (_Error) {
  _inherits(PorterError, _Error);

  function PorterError(status, response) {
    _classCallCheck(this, PorterError);

    var _this = _possibleConstructorReturn(this, (PorterError.__proto__ || Object.getPrototypeOf(PorterError)).call(this));

    _this.name = 'FetchError';
    _this.response = response;
    _this.status = status;
    return _this;
  }

  return PorterError;
}(Error);
/**
 * 发送打点的数据
 * @param url
 * @param name
 * @param type
 * @param startTime
 * @param reason
 */


var sendTrack = function sendTrack(url, name, type, startTime, reason) {
  var pattern = /^(https?:)?\/\/(.+)([\?\#].+)$/i;
  if (!name && pattern.test(url)) name = RegExp.$2;
  name = name || url;
  var duration = new Date() - startTime;
  var ext = 'name=' + name + '|type=' + type + '|time=' + duration;

  if (type === 'failure') {
    ext += '|reason=' + reason + '|url=' + url;
  }

  ; //积木盒子在预览的时候，可能没有dotstat

  window.dmtrack && window.dmtrack.dotstat && window.dmtrack.dotstat(27132, {
    ext: ext
  });
}; //确保Query包含?


var ensureQuery = function ensureQuery(url) {
  if (url.indexOf('?') < 0) {
    url += '?1=1';
  }

  ;
  return url;
}; //给url添加时间戳


var appendTimestamp = function appendTimestamp(url) {
  url = ensureQuery(url);
  return url + '&_=' + new Date().valueOf();
}; //给url添加ctoken


var appendCToken = function appendCToken(url) {
  var ctoken = _msccCookie2.default.getCToken(); //没有CToken,直接返回不处理


  if (!ctoken) return url;
  url = ensureQuery(url);
  return url + '&ctoken=' + ctoken;
}; // Ocean 方面称不要直接访问 gw.api.alibaba.com 域名


var changeDomain = function changeDomain(url) {
  return url.replace('gw.api.alibaba.com', 'gateway.alibaba.com');
}; //重新修订URL


var reviseUrl = function reviseUrl(url, options) {
  if (!options.noCache) url = appendTimestamp(url);
  if (options.ctoken !== false) url = appendCToken(url);
  url = changeDomain(url);
  return url;
};

var Porter = {
  //提供给外部用的打点功能
  sendTrack: sendTrack,
  //获取jsonp的数据
  jsonp: function jsonp(url, options) {
    var defaultOptions = {
      //默认60秒钟的时间
      timeout: 1000 * 60
    };
    var startTime = new Date();
    options = Object.assign({}, defaultOptions, options);
    options = addHavanaSession(url, options);
    url = reviseUrl(url, options); //发送打点
    // sendTrack(url, options.apiName, 'before', startTime);

    var result = (0, _fetchJsonp2.default)(url, options);
    return receiveData(result, url, options.apiName, startTime);
  },
  //直接处理ajax, 完全自定义
  fetch: function (_fetch) {
    function fetch(_x, _x2) {
      return _fetch.apply(this, arguments);
    }

    fetch.toString = function () {
      return _fetch.toString();
    };

    return fetch;
  }(function (url, options) {
    url = changeDomain(url);
    options = addHavanaSession(url, options);
    return fetch(url, options);
  })
}; //获取数据完成后的操作

var receiveData = function receiveData(result, url, apiName, startTime) {
  return result.then(function (res) {
    if (res.ok) {
      //成功的打点
      sendTrack(url, apiName, 'success', startTime);
      return res.json();
    }

    ; //失败的打点

    sendTrack(url, apiName, 'failure', startTime, res.status);
    var error = new PorterError(res.status, res);
    Porter.trigger('error', error);
    throw error;
  });
}; //异步获取数据, 数据格式为json, 同时会做异常捕获的处理


var normalFetch = function normalFetch(url, options, startTime) {
  var defaultOptions = {
    method: 'GET',
    //默认情况下, 包含cookies
    credentials: 'same-origin'
  };
  var ops = Object.assign({}, defaultOptions, options);
  ops = addHavanaSession(url, ops); //将对象的body转换为string

  if (_typeof(ops.body) === 'object' && !(ops.body instanceof FormData)) {
    ops.body = JSON.stringify(ops.body);
  } //url = appendTimestamp(url);
  //开始的打点


  sendTrack(url, options.apiName, 'send', startTime);
  return fetch(url, ops);
};

['put', 'delete', 'post', 'get'].forEach(function (method) {
  Porter[method] = function (url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    options.method = method;
    url = reviseUrl(url, options);
    var startTime = new Date();
    var result = normalFetch(url, options, startTime);
    return receiveData(result, url, options.apiName, startTime);
  };
});

_araleEvents2.default.mixTo(Porter);

exports.default = Porter;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
    factory(exports, module);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, mod);
    global.fetchJsonp = mod.exports;
  }
})(this, function (exports, module) {
  'use strict';

  var defaultOptions = {
    timeout: 5000,
    jsonpCallback: 'callback',
    jsonpCallbackFunction: null
  };

  function generateCallbackFunction() {
    return 'jsonp_' + Date.now() + '_' + Math.ceil(Math.random() * 100000);
  }

  function clearFunction(functionName) {
    // IE8 throws an exception when you try to delete a property on window
    // http://stackoverflow.com/a/1824228/751089
    try {
      delete window[functionName];
    } catch (e) {
      window[functionName] = undefined;
    }
  }

  function removeScript(scriptId) {
    var script = document.getElementById(scriptId);

    if (script) {
      document.getElementsByTagName('head')[0].removeChild(script);
    }
  }

  function fetchJsonp(_url) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1]; // to avoid param reassign

    var url = _url;
    var timeout = options.timeout || defaultOptions.timeout;
    var jsonpCallback = options.jsonpCallback || defaultOptions.jsonpCallback;
    var timeoutId = undefined;
    return new Promise(function (resolve, reject) {
      var callbackFunction = options.jsonpCallbackFunction || generateCallbackFunction();
      var scriptId = jsonpCallback + '_' + callbackFunction;

      window[callbackFunction] = function (response) {
        resolve({
          ok: true,
          // keep consistent with fetch API
          json: function json() {
            return Promise.resolve(response);
          }
        });
        if (timeoutId) clearTimeout(timeoutId);
        removeScript(scriptId);
        clearFunction(callbackFunction);
      }; // Check if the user set their own params, and if not add a ? to start a list of params


      url += url.indexOf('?') === -1 ? '?' : '&';
      var jsonpScript = document.createElement('script');
      jsonpScript.setAttribute('src', '' + url + jsonpCallback + '=' + callbackFunction);

      if (options.charset) {
        jsonpScript.setAttribute('charset', options.charset);
      }

      jsonpScript.id = scriptId;
      document.getElementsByTagName('head')[0].appendChild(jsonpScript);
      timeoutId = setTimeout(function () {
        reject(new Error('JSONP request to ' + _url + ' timed out'));
        clearFunction(callbackFunction);
        removeScript(scriptId);

        window[callbackFunction] = function () {
          clearFunction(callbackFunction);
        };
      }, timeout); // Caught if got 404/500

      jsonpScript.onerror = function () {
        reject(new Error('JSONP request to ' + _url + ' failed'));
        clearFunction(callbackFunction);
        removeScript(scriptId);
        if (timeoutId) clearTimeout(timeoutId);
      };
    });
  } // export as global function

  /*
  let local;
  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }
  local.fetchJsonp = fetchJsonp;
  */


  module.exports = fetchJsonp;
});

/***/ }),
/* 5 */
/***/ (function(module, exports) {

// Events
// -----------------
// Thanks to:
//  - https://github.com/documentcloud/backbone/blob/master/backbone.js
//  - https://github.com/joyent/node/blob/master/lib/events.js
// Regular expression used to split event strings
var eventSplitter = /\s+/; // A module that can be mixed in to *any object* in order to provide it
// with custom events. You may bind with `on` or remove with `off` callback
// functions to an event; `trigger`-ing an event fires all callbacks in
// succession.
//
//     var object = new Events();
//     object.on('expand', function(){ alert('expanded'); });
//     object.trigger('expand');
//

function Events() {} // Bind one or more space separated events, `events`, to a `callback`
// function. Passing `"all"` will bind the callback to all events fired.


Events.prototype.on = function (events, callback, context) {
  var cache, event, list;
  if (!callback) return this;
  cache = this.__events || (this.__events = {});
  events = events.split(eventSplitter);

  while (event = events.shift()) {
    list = cache[event] || (cache[event] = []);
    list.push(callback, context);
  }

  return this;
};

Events.prototype.once = function (events, callback, context) {
  var that = this;

  var cb = function cb() {
    that.off(events, cb);
    callback.apply(context || that, arguments);
  };

  return this.on(events, cb, context);
}; // Remove one or many callbacks. If `context` is null, removes all callbacks
// with that function. If `callback` is null, removes all callbacks for the
// event. If `events` is null, removes all bound callbacks for all events.


Events.prototype.off = function (events, callback, context) {
  var cache, event, list, i; // No events, or removing *all* events.

  if (!(cache = this.__events)) return this;

  if (!(events || callback || context)) {
    delete this.__events;
    return this;
  }

  events = events ? events.split(eventSplitter) : keys(cache); // Loop through the callback list, splicing where appropriate.

  while (event = events.shift()) {
    list = cache[event];
    if (!list) continue;

    if (!(callback || context)) {
      delete cache[event];
      continue;
    }

    for (i = list.length - 2; i >= 0; i -= 2) {
      if (!(callback && list[i] !== callback || context && list[i + 1] !== context)) {
        list.splice(i, 2);
      }
    }
  }

  return this;
}; // Trigger one or many events, firing all bound callbacks. Callbacks are
// passed the same arguments as `trigger` is, apart from the event name
// (unless you're listening on `"all"`, which will cause your callback to
// receive the true name of the event as the first argument).


Events.prototype.trigger = function (events) {
  var cache,
      event,
      all,
      list,
      i,
      len,
      rest = [],
      args,
      returned = true;
  if (!(cache = this.__events)) return this;
  events = events.split(eventSplitter); // Fill up `rest` with the callback arguments.  Since we're only copying
  // the tail of `arguments`, a loop is much faster than Array#slice.

  for (i = 1, len = arguments.length; i < len; i++) {
    rest[i - 1] = arguments[i];
  } // For each event, walk through the list of callbacks twice, first to
  // trigger the event, then to trigger any `"all"` callbacks.


  while (event = events.shift()) {
    // Copy callback lists to prevent modification.
    if (all = cache.all) all = all.slice();
    if (list = cache[event]) list = list.slice(); // Execute event callbacks except one named "all"

    if (event !== 'all') {
      returned = triggerEvents(list, rest, this) && returned;
    } // Execute "all" callbacks.


    returned = triggerEvents(all, [event].concat(rest), this) && returned;
  }

  return returned;
};

Events.prototype.emit = Events.prototype.trigger; // Helpers
// -------

var keys = Object.keys;

if (!keys) {
  keys = function keys(o) {
    var result = [];

    for (var name in o) {
      if (o.hasOwnProperty(name)) {
        result.push(name);
      }
    }

    return result;
  };
} // Mix `Events` to object instance or Class function.


Events.mixTo = function (receiver) {
  receiver = isFunction(receiver) ? receiver.prototype : receiver;
  var proto = Events.prototype;
  var event = new Events();

  for (var key in proto) {
    if (proto.hasOwnProperty(key)) {
      copyProto(key);
    }
  }

  function copyProto(key) {
    receiver[key] = function () {
      proto[key].apply(event, Array.prototype.slice.call(arguments));
      return this;
    };
  }
}; // Execute callbacks


function triggerEvents(list, args, context) {
  var pass = true;

  if (list) {
    var i = 0,
        l = list.length,
        a1 = args[0],
        a2 = args[1],
        a3 = args[2]; // call is faster than apply, optimize less than 3 argu
    // http://blog.csdn.net/zhengyinhui100/article/details/7837127

    switch (args.length) {
      case 0:
        for (; i < l; i += 2) {
          pass = list[i].call(list[i + 1] || context) !== false && pass;
        }

        break;

      case 1:
        for (; i < l; i += 2) {
          pass = list[i].call(list[i + 1] || context, a1) !== false && pass;
        }

        break;

      case 2:
        for (; i < l; i += 2) {
          pass = list[i].call(list[i + 1] || context, a1, a2) !== false && pass;
        }

        break;

      case 3:
        for (; i < l; i += 2) {
          pass = list[i].call(list[i + 1] || context, a1, a2, a3) !== false && pass;
        }

        break;

      default:
        for (; i < l; i += 2) {
          pass = list[i].apply(list[i + 1] || context, args) !== false && pass;
        }

        break;
    }
  } // trigger will return false if one of the callbacks return false


  return pass;
}

function isFunction(func) {
  return Object.prototype.toString.call(func) === '[object Function]';
}

module.exports = Events;

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/@alife/mscc-cookie/src/cookie.js
// Cookie
// -------------
// Thanks to:
//  - http://www.nczonline.net/blog/2009/05/05/http-cookies-explained/
//  - http://developer.yahoo.com/yui/3/cookie/
var Cookie = {};
var decode = decodeURIComponent;
var encode = encodeURIComponent;
/**
 * Returns the cookie value for the given name.
 *
 * @param {String} name The name of the cookie to retrieve.
 *
 * @param {Function|Object} options (Optional) An object containing one or
 *     more cookie options: raw (true/false) and converter (a function).
 *     The converter function is run on the value before returning it. The
 *     function is not used if the cookie doesn't exist. The function can be
 *     passed instead of the options object for conveniently. When raw is
 *     set to true, the cookie value is not URI decoded.
 *
 * @return {*} If no converter is specified, returns a string or undefined
 *     if the cookie doesn't exist. If the converter is specified, returns
 *     the value returned from the converter.
 */

Cookie.get = function (name, options) {
  validateCookieName(name);

  if (typeof options === 'function') {
    options = {
      converter: options
    };
  } else {
    options = options || {};
  }

  var cookies = parseCookieString(document.cookie, !options['raw']);
  return (options.converter || same)(cookies[name]);
};
/**
 * Sets a cookie with a given name and value.
 *
 * @param {string} name The name of the cookie to set.
 *
 * @param {*} value The value to set for the cookie.
 *
 * @param {Object} options (Optional) An object containing one or more
 *     cookie options: path (a string), domain (a string),
 *     expires (number or a Date object), secure (true/false),
 *     and raw (true/false). Setting raw to true indicates that the cookie
 *     should not be URI encoded before being set.
 *
 * @return {string} The created cookie string.
 */


Cookie.set = function (name, value, options) {
  validateCookieName(name);
  options = options || {};
  var expires = options['expires'];
  var domain = options['domain'];
  var path = options['path'];

  if (!options['raw']) {
    value = encode(String(value));
  }

  var text = name + '=' + value; // expires

  var date = expires;

  if (typeof date === 'number') {
    date = new Date();
    date.setDate(date.getDate() + expires);
  }

  if (date instanceof Date) {
    text += '; expires=' + date.toUTCString();
  } // domain


  if (isNonEmptyString(domain)) {
    text += '; domain=' + domain;
  } // path


  if (isNonEmptyString(path)) {
    text += '; path=' + path;
  } // secure


  if (options['secure']) {
    text += '; secure';
  }

  document.cookie = text;
  return text;
};
/**
 * Removes a cookie from the machine by setting its expiration date to
 * sometime in the past.
 *
 * @param {string} name The name of the cookie to remove.
 *
 * @param {Object} options (Optional) An object containing one or more
 *     cookie options: path (a string), domain (a string),
 *     and secure (true/false). The expires option will be overwritten
 *     by the method.
 *
 * @return {string} The created cookie string.
 */


Cookie.remove = function (name, options) {
  options = options || {};
  options['expires'] = new Date(0);
  return this.set(name, '', options);
};

function parseCookieString(text, shouldDecode) {
  var cookies = {};

  if (isString(text) && text.length > 0) {
    var decodeValue = shouldDecode ? decode : same;
    var cookieParts = text.split(/;\s/g);
    var cookieName;
    var cookieValue;
    var cookieNameValue;

    for (var i = 0, len = cookieParts.length; i < len; i++) {
      // Check for normally-formatted cookie (name-value)
      cookieNameValue = cookieParts[i].match(/([^=]+)=/i);

      if (cookieNameValue instanceof Array) {
        try {
          cookieName = decode(cookieNameValue[1]);
          cookieValue = decodeValue(cookieParts[i].substring(cookieNameValue[1].length + 1));
        } catch (ex) {// Intentionally ignore the cookie -
          // the encoding is wrong
        }
      } else {
        // Means the cookie does not have an "=", so treat it as
        // a boolean flag
        cookieName = decode(cookieParts[i]);
        cookieValue = '';
      }

      if (cookieName) {
        cookies[cookieName] = cookieValue;
      }
    }
  }

  return cookies;
} // Helpers


function isString(o) {
  return typeof o === 'string';
}

function isNonEmptyString(s) {
  return isString(s) && s !== '';
}

function validateCookieName(name) {
  if (!isNonEmptyString(name)) {
    throw new TypeError('Cookie name must be a non-empty string');
  }
}

function same(s) {
  return s;
}

/* harmony default export */ var cookie = (Cookie);
// CONCATENATED MODULE: ./node_modules/@alife/mscc-cookie/src/cookie-info.js

/*
 * 分析
 */

var parser = function parser(raw) {
  var result = {};
  if (!raw) return result;
  var list = raw.split('&');
  list.map(function (current) {
    var arr = current.split('=');
    var key = arr[0];
    var value = arr[1];
    result[key] = value;
  });
  return result;
}; //分析xman_us_f中x_user的信息


var analysisUser = function analysisUser(raw) {
  //替换掉用户信息中可能存在的<>
  raw = (raw || '').replace(/</g, "&lt;").replace(/>/g, "&gt;");
  var list = raw.split('|');
  return {
    country: list[0],
    lastName: list[1],
    firstName: list[2],
    serviceType: list[3],
    memberSeq: list[4]
  };
}; //分析xman的数据


var cookie_info_analysisXman = function analysisXman() {
  var raw = cookie.get('xman_us_f') || '';
  var result = parser(raw);
  result.x_user = analysisUser(result.x_user);
  /*
  const list = raw.split('&');
  list.map(function(current){
      const arr = current.split('=');
      const key = arr[0];
       let value = arr[1];
      if(key === 'x_user'){
          value = analysisUser(value) || {};
      };
       result[key] = value;
  });
  */

  return result;
}; //获取beacon id


var cookie_info_getBeaconId = function getBeaconId() {
  return cookie.get('ali_beacon_id');
}; //获取cna的值


var cookie_info_getCna = function getCna() {
  return cookie.get('cna');
}; //判断用户是否登录


var cookie_info_getIsLoggedIn = function getIsLoggedIn() {
  var value = cookie.get('xman_us_t');
  return value && value.indexOf('sign=y') !== -1;
}; //获取用户的id


var cookie_info_getUserId = function getUserId() {
  return (cookie.get('ali_apache_track') || '').replace(/.+mid=(.+)$/, '$1').replace(/"/g, '');
}; //用户是否第一次登录


var cookie_info_getIsFirstIn = function getIsFirstIn() {
  return cookie.get('ali_intl_firstIn') === '';
}; //获取本地语言


var cookie_info_getLanguage = function getLanguage() {
  var value = cookie.get('intl_locale');
  return value || cookie_info_analysisXman().x_locale || 'en_US';
}; //获取用户信息, 可以通过这个获取用户的完全信息


var getUser = function getUser() {
  return cookie_info_analysisXman().x_user;
}; //是否海外用户


var getIsOversea = function getIsOversea() {
  return cookie_info_analysisXman().x_l == '0';
}; //是否有新用户


var getIsNewUser = function getIsNewUser() {
  return cookie_info_analysisXman().x_user.memberSeq !== '';
}; // 服务器地域


var getServerDomain = function getServerDomain() {
  var hzServiceType = ['gs', 'cgs', 'twgs', 'hkgs', 'cnfm'];
  var userType = cookie_info_analysisXman().x_user.serviceType;
  return hzServiceType.indexOf(userType) > -1 ? 'hz' : 'us';
}; //获取ctoken


var cookie_info_getCToken = function getCToken() {
  var value = cookie.get('xman_us_t') || '';
  var list = parser(value);
  return list.ctoken || '';
};

/* harmony default export */ var cookie_info = ({
  //核心方法
  core: cookie,
  //获取beaconId
  getBeaconId: cookie_info_getBeaconId,
  //获取CNA
  getCna: cookie_info_getCna,
  //判断用户是否登录
  getIsLoggedIn: cookie_info_getIsLoggedIn,
  //获取用户的id
  getUserId: cookie_info_getUserId,
  //用户是否第一次登录
  getIsFirstIn: cookie_info_getIsFirstIn,
  //获取本地语言
  getLanguage: cookie_info_getLanguage,
  //获取用户信息, 可以通过这个获取用户的完全信息
  getUser: getUser,
  //是否海外用户
  getIsOversea: getIsOversea,
  //是否有新用户
  getIsNewUser: getIsNewUser,
  //服务器地域
  getServerDomain: getServerDomain,
  //获取CToken
  getCToken: cookie_info_getCToken
});
/*
 // 是否登录
let isLoggedIn = false,
 // 是否是新用户
_isNewUser = false,
// 是否第一次登录
isFirstIn = true,
// 当前登录用户注册时所在的国家
country = '',

firstName = '',
lastName = '',
serviceType = '',
memberSeq = '',
userId = '',
// 页面显示语言，默认en_US。这个会决定webuser.getLocal().
locale = '';



let setup = function() {
    let usfCookieMap = {};
    if (cookie.get('xman_us_f')) {
        let usfCookieArr = cookie.get('xman_us_f').split('&');
        for (let i = usfCookieArr.length; i--;) {
            let tempCookieArr = usfCookieArr[i].split('=');
            usfCookieMap[tempCookieArr[0]] = tempCookieArr[1];
        }
    }
    let isLoginCookie = cookie.get('xman_us_t');
    let userCookie = cookie.get('xman_us_f');
    let userReg = /x_user=([^&"]+)/;

    // 是否登录
    if (isLoginCookie && isLoginCookie.indexOf('sign=y') !== -1) {
        isLoggedIn = true;
    } else {
        isLoggedIn = false;
    }

    // 获得用户基本信息，曾经登录过并且在cookie中有用户信息。
    if (userCookie && userReg.test(userCookie)) {
        userCookie.match(userReg);
        userCookie = RegExp.$1;
        userCookie = userCookie.split('|');

        if (userCookie.length >= 5) {
            country = userCookie[0];
            firstName = userCookie[1].replace(/</g, "&lt;").replace(/>/g, "&gt;");
            lastName = userCookie[2].replace(/</g, "&lt;").replace(/>/g, "&gt;");
            serviceType = userCookie[3];
            memberSeq = userCookie[4];
        }
    }

    // 是否是新用户
    if (memberSeq !== '') {
        _isNewUser = true;
    }

    // 是否是第一次登录
    if (cookie.get('ali_intl_firstIn') === '') {
        isFirstIn = true;
    }

    // 获取当前语言。
    if (cookie.get('intl_locale')) {
        locale = cookie.get('intl_locale');
    } else {
        // 针对AE国家分站,使用新的key,判断用户是哪个站点
        let xLocale = usfCookieMap['x_locale'];
        if (xLocale) {
            locale = xLocale;
        } else {
            locale = 'en_US';
        }

    }

    return this;
};

// 立即初始化
setup();


let getIsOversea = function() {
    let isOversea = true;
    let userCookie = cookie.get('xman_us_f');

    // 国内
    if (userCookie && userCookie.indexOf('x_l=1') !== -1) {
        isOversea = false;
    }

    // 国外
    if (userCookie && userCookie.indexOf('x_l=0') !== -1) {
        isOversea = true;
    }

    return isOversea;
};

let isNewUser = () => {
    // 根据memberseq是否存在来判断是否是新用户
    let result = true;
    if (memberSeq !== '') {
        _isNewUser = false;
        result = false;
    }
    return result;
}


export default {
    isLoggedIn: isLoggedIn,
    isNewUser: isNewUser(),
    isFirstIn: isFirstIn,
    country: country,
    firstName: firstName,
    lastName: lastName,
    serviceType: serviceType,
    memberSeq: memberSeq,
    locale: locale,

    getUserId(){

    },

    // 服务器地域
    serverDomain() {
        let hzServiceType;
        setup();
        hzServiceType = ['gs', 'cgs', 'twgs', 'hkgs', 'cnfm'];
        if (hzServiceType.indexOf(serviceType) > -1) {
            return 'hz';
        }
        return 'us';
    },
    getIsLoggedIn() {
        setup();
        return isLoggedIn;
    },
    getIsNewUser() {
        setup();
        return isNewUser();
    },
    getCountry() {
        setup();
        return country;
    },
    getFirstName() {
        setup();
        return firstName;
    },
    getLastName() {
        setup();
        return lastName;
    },
    getServiceType() {
        setup();
        return serviceType;
    },
    getMemberSeq() {
        setup();
        return memberSeq;
    },
    getLanguage() {
        setup();
        return locale;
    },
    getIsOversea: getIsOversea
};
*/
// CONCATENATED MODULE: ./node_modules/@alife/mscc-cookie/src/index.js
/**
 * Created by 易晓峰(林异)<yxf@106063@alibaba-inc.com> on 16/7/12.
 */

/* harmony default export */ var src = __webpack_exports__["default"] = (cookie_info);

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index.js